import React, { useState } from "react";
import Location from "../tracker/Location";
import { Link, withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { LinkContainer } from "react-router-bootstrap";

const Awaiting = ({ awaiting, drivers }) => {
  return (
    <div className="container-fluid">
      <Accordion>
        {awaiting.map((awd, i) => {
          const driver = drivers.find(
            (driv) => driv.id === awaiting[i].driver_id
          );
          return (
            <Card key={i}>
              <Accordion.Toggle
                as={Button}
                variant={
                  awaiting[i].pickup ? "outline-secondary" : "outline-info"
                }
                eventKey={`${awaiting[i].id}`}
              >
                {awaiting[i].name}: {awaiting[i].order_number} (
                {awaiting[i].pickup
                  ? awaiting[i].shipfrom_name
                  : `${awaiting[i].shipto_first_name} ${awaiting[i].shipto_last_name}`}
                ) {moment(awaiting[i].date).format("MMM DD")}
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={`${awaiting[i].id}`}>
                <Card.Body>
                  Destination: {awaiting[i].shipto_address1}{" "}
                  {awaiting[i].shipto_address2}, {awaiting[i].shipto_city},{" "}
                  {awaiting[i].shipto_zip} <br></br>
                  {awaiting[i].shipto_phone &&
                    `Contact: ${awaiting[i].shipto_phone}`}{" "}
                  {awaiting[i].email &&
                    `Email: 
                ${awaiting[i].email}\n`}
                  <br></br>
                  Total Price: {awaiting[i].total_price} <br></br>
                  {awaiting[i].retailers_notes &&
                    `Notes: 
                ${awaiting[i].retailers_notes}\n`}
                  {awaiting[i].number_of_bags &&
                    `Number of Bags: 
                ${awaiting[i].number_of_bags}`}{" "}
                  <br></br>
                  Customer Instructions: {
                    awaiting[i].delivery_instructions
                  }{" "}
                  <br></br>
                  {awaiting[i].delivery_window &&
                    `Selected Time: 
                ${awaiting[i].delivery_window}`}
                  <br></br>
                  {awaiting[i].pick_up_time &&
                    awaiting[i].driver_id &&
                    `Picked Up By: 
                    ${driver.first_name} at ${moment(
                      awaiting[i].pick_up_time
                    ).format("MMMM Do YYYY, h:mm:ss a")}`}
                  <br></br>
                  <LinkContainer to={`/fulfillments/${awaiting[i].order_id}`}>
                    <Button variant="danger">Delivery Details</Button>
                  </LinkContainer>
                  <LinkContainer to={`/rescheduleDelivery/${awaiting[i].id}`}>
                    <Button variant="warning">Reschedule</Button>
                  </LinkContainer>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    </div>
  );
};

export default withRouter(Awaiting);
